import React, { useState } from "react";
import MobilePop from "../../utils/MobilePop";
import CloseComponent from "../../components/CloseComponent/CloseComponent";
import { Dropdown } from "semantic-ui-react";
import LanguageSettings from "./components/LanguageSettings";
import { useTranslation } from "react-i18next";
import Wrapper from "./components/Wrapper";
import Text from "./components/Text";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import DetailWrapper from "../../components/detailWrapper";
import { BiSolidLockAlt, BiSolidUser, BiSolidUserCircle } from "react-icons/bi";
import { HiChevronRight } from "react-icons/hi";
import { MdOutlineLanguage } from "react-icons/md";
import LanguagePage from "./components/LanguagePage";
import { useDispatch, useSelector } from "react-redux";
import { openLanguagePop } from "../../redux/action/member/memberAction";
import { useNavigate } from "react-router";
import { RiProfileFill } from "react-icons/ri";
import { BsShieldFillCheck } from "react-icons/bs";
import { IoIosMoon, IoMdSunny } from "react-icons/io";
import ThemeTab from "./components/themeTab";
import { FaHeadphonesAlt } from "react-icons/fa";
import { AiOutlineClear } from "react-icons/ai";

const Settings = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  const [settingTab, setSettingTab] = useState("");

  const navigate = useNavigate();

  const profile_settings = [
    {
      label: i18n("personalInformation"),
      icon: <BiSolidUserCircle />,
      path: "personal-data",
    },
    {
      label: i18n("bindIdCard"),
      icon: <RiProfileFill />,
      path: "bind-id-card",
    },
    {
      label: i18n("resetPassword"),
      icon: <BiSolidLockAlt />,
      path: "reset-password",
    },
    {
      label: i18n("resetWithdrawPassword"),
      icon: <BiSolidLockAlt />,
      path: "reset-withdraw-password",
    },
    {
      label: i18n("userSecureVerity"),
      icon: <BsShieldFillCheck />,
      divider: true,
      path: "user-secure-verity",
    },

    {
      label: i18n("Language"),
      icon: <MdOutlineLanguage />,
      function: () => {
        dispatch(openLanguagePop());
      },
    },
    {
      label: i18n("ColorTheme"),
      icon: isDarkMode ? <IoIosMoon /> : <IoMdSunny />,
      divider: true,
      tab: "color-theme",
      children: <ThemeTab />,
      function: () => {
        if (settingTab === "color-theme") {
          setSettingTab("");
          return;
        }
        setSettingTab("color-theme");
      },
    },
  ];

  return (
    <DetailWrapper>
      <section>
        <CloseDetailPage title={i18n("title")} />

        <section className="flex flex-col gap-[2px]">
          {profile_settings.map((item, index) => {
            return (
              <div
                className={`${
                  item.divider && "mb-[8px]"
                } hover:bg-hover-transaction-card bg-transaction-card dark:bg-base-light-dark cursor-pointer rounded-[5px] py-[10px] px-[8px] text-light-text text-lg font-medium flex flex-col gap-[10px]`}
              >
                <section
                  onClick={() => {
                    item.function && item.function();
                    if (item.path) {
                      navigate(item.path);
                    }
                  }}
                  className="flex items-center justify-between hover:dark:text-base-light-white hover:text-main-color"
                >
                  <div className="flex items-center gap-[5px]">
                    <span className="text-xl">{item.icon}</span>
                    <span className="font-medium">{item.label}</span>
                  </div>
                  <HiChevronRight className={`${item.active && "rotate-90"}`} />
                </section>
                {settingTab === item.tab && item.children}
              </div>
            );
          })}
        </section>
      </section>
    </DetailWrapper>
  );
};

export default Settings;
